export const PLACE_ORDER = 'ORDER/PLACE_ORDER';
export const PLACE_ORDER_SUCCESS = 'ORDER/PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_ERROR = 'ORDER/PLACE_ORDER_ERROR';
export const SET_SHIP_NAME = 'ORDER/SET_SHIP_NAME';
export const SET_SHIP_ADDRESS_1 = 'ORDER/SET_SHIP_ADDRESS_1';
export const SET_SHIP_ADDRESS_2 = 'ORDER/SET_SHIP_ADDRESS_2';
export const SET_SHIP_CITY = 'ORDER/SET_SHIP_CITY';
export const SET_SHIP_STATE = 'ORDER/SET_SHIP_STATE';
export const SET_SHIP_ZIP = 'ORDER/SET_SHIP_ZIP';
export const SET_SHIP_PHONE = 'ORDER/SET_SHIP_PHONE';
export const SET_SHIP_EMAIL = 'ORDER/SET_SHIP_EMAIL';
export const SET_SHIP_NOTES = 'ORDER/SET_SHIP_NOTES';
export const SET_BILL_NAME = 'ORDER/SET_BILL_NAME';
export const SET_BILL_ADDRESS_1 = 'ORDER/SET_BILL_ADDRESS_1';
export const SET_BILL_ADDRESS_2 = 'ORDER/SET_BILL_ADDRESS_2';
export const SET_BILL_CITY = 'ORDER/SET_BILL_CITY';
export const SET_BILL_STATE = 'ORDER/SET_BILL_STATE';
export const SET_BILL_ZIP = 'ORDER/SET_BILL_ZIP';
export const SET_BILL_PHONE = 'ORDER/SET_BILL_PHONE';
export const SET_BILL_EMAIL = 'ORDER/SET_BILL_EMAIL';
export const SET_BILL_PO = 'ORDER/SET_BILL_PO';
export const SET_BILL_DEPARTMENT = 'ORDER/SET_BILL_DEPARTMENT';
export const SET_BILL_CALL = 'ORDER/SET_BILL_CALL';
export const SET_BILL_NOTES = 'ORDER/SET_BILL_NOTES';
export const SET_SAME_ADDRESS = 'ORDER/SET_SAME_ADDRESS';
export const SET_CARD_NUMBER = 'ORDER/SET_CARD_NUMBER';
export const SET_NAME_ON_CARD = 'ORDER/SET_NAME_ON_CARD';
export const SET_EXPIRATION_MONTH = 'ORDER/SET_EXPIRATION_MONTH';
export const SET_EXPIRATION_YEAR = 'ORDER/SET_EXPIRATION_YEAR';
export const SET_SECURITY_NUMBER = 'ORDER/SET_SECURITY_NUMBER';
export const SET_REFERENCE_FILES = 'ORDER/SET_REFERENCE_FILES';
export const SET_ORDER_ID = 'ORDER/SET_ORDER_ID';
export const RESET_STATE = 'ORDER/RESET_STATE';